import { observer } from 'mobx-react';
import * as React from 'react';
import { FormControl } from 'react-bootstrap';
import { inject } from '../../../../utils/decorators';
import { VorgangStore } from '../../../../stores/VorgangStore';
import { ApiStore } from '../../../../stores/ApiStore';
import { BpsReferenzkraftKalibrierungPlatteStore } from '../../../../stores/BpsReferenzkraftKalibrierungPlatteStore';
import BpsPruefortParameter from './BpsPruefortParameter';
import BpsReferenzkraftKMGInfo from './../BpsReferenzkraftKMGInfo';
import * as ApiTypesBps from '../../../../models/ApiTypesBpsPlatte';
import Callout from '../../../site/Callout';
import BpsReferenzkraftPlattensaetze from './BpsReferenzkraftPlattensaetze';
import BpsReferenzkraftWaegezelle from './BpsReferenzkraftWaegezelle';

export interface IBpsReferenzkraftkalibrierungProps {
  elementguid: string;
  kategorieguid: string;
  editable?: boolean;
  value?: string;
}

/** Kapselkomponente für die Kalibrierung von Plattenbremsprüfständen nach Referenzkraftverfahren nach Richtlinie 2021 */
@observer
export default class BpsReferenzkraftKalibrierungPlatteRili2021 extends React.Component<IBpsReferenzkraftkalibrierungProps, {}> {

  @inject(VorgangStore) vorgangStore: VorgangStore;
  @inject(ApiStore) apiStore: ApiStore;
  @inject(BpsReferenzkraftKalibrierungPlatteStore) kalibrierungStore: BpsReferenzkraftKalibrierungPlatteStore;

  constructor(props: IBpsReferenzkraftkalibrierungProps) {
    super(props);
    this.kalibrierungStore.clear();
  }

  async componentDidMount() {
    // Für die Berechnung und Auswertung werden der Bremsenprüfstand und das Kraftmessgerät (Arbeitsmittel) aus dem aktuellen Vorgang benötigt
    let vorgang = this.vorgangStore.vorgang;

    if (vorgang && vorgang.objekte) {
      // Für die Berechnung muss ein Kraftmessgerät aus dem Vorgang gewählt werden
      var kmg = vorgang.arbeitsmittel.find((e) => { return e.typ.toLowerCase() === 'bps_kmg'; });
      this.kalibrierungStore.setKraftMessGeraet(kmg);
      // Für die Berechnung muss der zu betrachtende Bremsprüfstand aus dem Vorgang gewählt werden
      var bps = vorgang.objekte.find((e) => { return e.typ.toLowerCase() === 'bps'; });
      this.kalibrierungStore.setKalibrierGegenstand(bps);
      // Für die Berechnung wird auch die Objektvorlage benötigt, auf deren Basis der Bremsprüfstand angelegt wurde
      if (bps) {
        const response = await this.apiStore.objektVorlage(bps.objektguid);
        if (response.ok) {
          this.kalibrierungStore.setObjektVorlage(response.json);
        }
      }
    }

    // Gespeicherte Messung übernehmen
    if (this.props.value) {
      let messung: ApiTypesBps.IBpsReferenzkraftMessungPlatte = this.kalibrierungStore.datensatz;
      messung = JSON.parse(this.props.value) as ApiTypesBps.IBpsReferenzkraftMessungPlatte;
      this.kalibrierungStore.setMesswerte(messung);
    }
    this.kalibrierungStore.setReadOnly(this.props.editable ? !this.props.editable : true);
  }

  render() {
    if (!this.kalibrierungStore.kalibrierGegenstand || !this.kalibrierungStore.objektVorlage || !this.kalibrierungStore.kraftMessGeraet) {
      return (
        <Callout bsStyle="danger">
          <p>Bitte wählen Sie für die Auswertung zuerst einen Plattenbremsprüfstand und ein Arbeitsmittelset mit einem Kraftmessgerät aus</p>
        </Callout>
      );
    }
    if (this.kalibrierungStore.kalibrierGegenstand.objekt && this.kalibrierungStore.kalibrierGegenstand.objekt.art !== ApiTypesBps.BpsArt.Platte) {
      return (
        <Callout bsStyle="danger">
          <p>Bitte wählen Sie für die Auswertung einen Plattenbremsprüfstand aus (es wurde ein Rollenprüfstand gewählt)</p>
        </Callout>
      );
    }
    return (
      <div>
        <BpsReferenzkraftKMGInfo/>
        <BpsPruefortParameter titel="Prüfortparameter zu Beginn der Kalibrierung" ziel={this.kalibrierungStore.datensatz.pruefortparameter.beginn}/>
        <BpsReferenzkraftWaegezelle/>
        <BpsReferenzkraftPlattensaetze/>
        <BpsPruefortParameter titel="Prüfortparameter am Ende der Kalibrierung" ziel={this.kalibrierungStore.datensatz.pruefortparameter.ende}/>
        {/* Kompletten Messdatensatz als verstecktes Feld im Request übergeben */}
        <FormControl type="hidden" name={`${this.props.kategorieguid}[${this.props.elementguid}][json]`} value={JSON.stringify(this.kalibrierungStore.datensatz)}/>
      </div>
    );
  }

}



// WEBPACK FOOTER //
// ./~/tslint-loader!./src/components/vorlagen/bps/platte/BpsReferenzkraftKalibrierungPlatteRili2021.tsx